/**
 * @desc payHandle处理第三方支付流程
 * @desc 使用方式：payHandle.call(this,{apiResul:xxx}) //需要绑定this
 * @param apiResul 返回结果
 * @param orderType 订单类型
 * @returns {Promise<Awaited<boolean|*>>|Promise<* | void>}
 */

import { useStore } from '@/store';
import { addEventerHelper } from '@/utils';
import { useEffect } from 'react';
import { debounce } from 'lodash';
import { DEVICE_TYPE, DEVICE_WIDTH_MAP } from '@/types';





const useDevice = () => {
  const { setDevice } = useStore();
  const handleResize = () => {
    // console.log('[dev]看看-window.innerWidth:', window.innerWidth);
    const w = window.innerWidth;
    if (w >= DEVICE_WIDTH_MAP.PC) {
      setDevice(DEVICE_TYPE.PC);
    } else if (w < DEVICE_WIDTH_MAP.PC && w >= DEVICE_WIDTH_MAP.PAD) {
      setDevice(DEVICE_TYPE.PAD);
    } else if (w < DEVICE_WIDTH_MAP.PAD) {
      setDevice(DEVICE_TYPE.H5);
    }
  };

  useEffect(() => {
    let destroy;
    // console.log('[dev]看看-handleResize:', handleResize);
    handleResize();
    destroy = addEventerHelper({
      event: 'resize',
      element: window,
      listener: debounce(handleResize, 150),
    });

    return () => {
      destroy?.();
    };
  }, []);
};

export default useDevice;
